import ViewPoLineException from './view-po-line-exceptions'

export default class PoExceptions {
    items : Array<ViewPoLineException>;
}